module.exports = __webpack_public_path__ + "img/paw2.0aee7d57.svg";